import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {

    static get API_URL(): string {
        return environment.appUrl + 'api/';
    }

    static get APP_URL(): string {
        return environment.appUrl + 'admin/';
    }

    static get LOGIN(): string {
        return AppUrl.APP_URL + 'login';
    }


    static get SELF(): string {
        return AppUrl.APP_URL + 'self';
    }

    static UPDATE_SELF(): string {
        return AppUrl.API_URL + 'update-self';
    }

    static LOGOUT(): string {
        return AppUrl.API_URL + 'logout';
    }
    static ALL_CONTACT(): string {
        return AppUrl.APP_URL + 'contact-us';
    }
    static COURSES(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'course/' + id;
        } else {
            return AppUrl.APP_URL + 'course';
        }
    }
    static CATEGORY(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'category/' + id;
        } else {
            return AppUrl.APP_URL + 'category';
        }
    }
    static UNIVERSITY(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'university/' + id;
        } else {
            return AppUrl.APP_URL + 'university';
        }
    }
    static COURSES_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'course-status/' + id;
        }
    }
    static CATEGORY_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'category-status/' + id;
        }
    }
    static UNIVERSITY_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'university-status/' + id;
        }
    }
    static EBOOK(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'e-book/' + id;
        } else {
            return AppUrl.APP_URL + 'e-book';
        }
    }
    static EBOOK_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'e-book-status/' + id;
        }
    }
    static LECTURE(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'lecture/' + id;
        } else {
            return AppUrl.APP_URL + 'lecture';
        }
    }
    static LECTURE_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'lecture-status/' + id;
        }
    }
    static FILE_UPLOAD(): string {
        return AppUrl.APP_URL + 'file-upload';
    }


}
